/* eslint-disable react-hooks/exhaustive-deps */
//https://codepen.io/soulwire/pen/mEMPrK
import { useEffect, useRef, useState } from "react"
import { IPrimitiveProps } from "../../section/Primitive"
import { SCRAMBLES } from "../WriterPrimitive"
import { TEXT_SIZE, WriterContent } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { useInViewport } from "src/modules/pe-landing-module/hooks/useInViewport"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import { getCssDemention } from "src/libs/utilities"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { TextAlignment } from "@blueprintjs/core"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"

/* Protopia Ecosystem component */ 
const Scramble = (props: IPrimitiveProps): JSX.Element => {
    const isEdit = useLandingStore((state: ILandingStore) => state.isEdit)
    const ref = useRef(null)
    const primitive: WriterContent = (props.primitive || {}) as WriterContent 
    const position = usePosition( primitive ).position  
    const text = primitive.text 
    const [phrases]     = useState<string[]>( ['', ...text.replaceAll("<br>", "\n").replaceAll("</p><p>", "\n").split("\n")] )
    const [fx, setFx]   = useState<TextScramble>(  )
    const inViewport    = useInViewport(ref, 300)

    const onStart = () => {  
        if(!fx) return 
        let counter = 0
        const next = () => {
            fx.setText(phrases[counter]).then(() => {
                setTimeout( next, 2500 )
            })
            counter = (counter + 1) % phrases.length
        } 
        next()
    } 
    
    useEffect(() => {
        addCSSClass(
            `primitive-writer-${ primitive.id }`,
            ` .primitive-writer-${ primitive.id } { 
                user-select:none;
                width:${ getCssDemention(position.width, "200px") };
                //height:${ getCssDemention(position.height, "200px") };
                ${ position.opacity ? `opacity:${ position.opacity };` : ``}
                ${ `transform: scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg) skew(-6deg, 0);` }
                text-align:${primitive.text_align || TextAlignment.CENTER};
                ${ primitive.font_size   ? `font-size: ${ primitive.font_size }px;` : "" }
                ${ primitive.text_color  ? `color: ${primitive.text_color}` : "" };
                ${ primitive.font ? `font-family: ${primitive.font }!important` : ""

            }`
        )  
        setFx(new TextScramble(ref.current! as any))
        return () => removeCSSClass(`primitive-writer-${ primitive.id }`)
    }, [])

    useEffect(() => { 
        
        if(inViewport) {
            onStart()
        }
    }, [ inViewport ])

    return <div 
        ref={ref}
        style={ primitive.style }
        className={`${isEdit ? "" : "" } pe-scramble primitive-writer-${ primitive.id } ${ primitive.className }` }
        onClick={onStart} 
    >

    </div>
}
export default Scramble


class TextScramble {
    el
    frame: number = 0 
    queue: any
    resolve: any
    frameRequest: any

    constructor(el: any) {
        this.el = el 
        this.update = this.update.bind(this)
    }
    setText(newText: string) {
        const oldText = this.el.innerText
        const length = Math.max(oldText.length, newText.length)
        const promise = new Promise((resolve) => this.resolve = resolve)
        this.queue = []
        for (let i = 0; i < length; i++) {
            const from = oldText[i] || ''
            const to = newText[i] || ''
            const start = Math.floor(Math.random() * 70)
            const end = start + Math.floor(Math.random() * 70)
            this.queue.push({ from, to, start, end })
        }
        cancelAnimationFrame(this.frameRequest)
        this.frame = 0
        this.update()
        return promise
    }
    update() {
        let output = ''
        let complete = 0
        for (let i = 0, n = this.queue.length; i < n; i++) {
            let { from, to, start, end, char } = this.queue[i]
            if (this.frame >= end) {
                complete++
                output += to
            } else if (this.frame >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar()
                    this.queue[i].char = char
                }
                output += `<span class=${ char === "." ? "dud blips" : "dud"}>${char}</span>`
            } else {
                output += from
            }
        }
        this.el.innerHTML = output + `<span class="blips">.</span>`
        if (complete === this.queue.length) {
            this.resolve()
        } else {
            this.frameRequest = requestAnimationFrame(this.update)
            this.frame++
        }
    }
    randomChar() {
        return SCRAMBLES[Math.floor(Math.random() * SCRAMBLES.length)]
    }
}


